import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";


const Editor = ({ onChange,value,placeholder,readOnly=false }) => {
  return (
      <ReactQuill
        theme="snow"
        value={value}
        readOnly={readOnly}    
        onChange={onChange}
        modules={{
          toolbar: false, // 🔥 Hide all tools
        }}
        // formats={[]} // 🔒 No formatting allowed
        placeholder={placeholder}
      />
  );
};

export default Editor;
